import keyMirror from 'fbjs/lib/keyMirror';

export default keyMirror({
  // 用户登录
  LOGIN_SET_FORM_DATA: null,
  LOGIN_SUCCESS: null,
  LOGIN_FAIL: null,
  LOGIN_HIDE_ERROR: null,
});



// WEBPACK FOOTER //
// ./actions/type/login.js